import type { Except, Merge } from 'type-fest';
import { useField } from '../../../hooks/useField';
import {
    Controlled_MultilineStringInput,
    type Controlled_MultilineStringInputProps,
} from '../../inputs/controlled/Controlled_MultilineStringInput';
import type { StringOrNullableString } from '../../inputs/controlled/types';

export type Form_MultilineStringInputProps<
    T extends object,
    N extends boolean,
> = Merge<
    Except<
        Controlled_MultilineStringInputProps<N>,
        keyof useField.Result<StringOrNullableString<N>>
    >,
    useField.Props<StringOrNullableString<N>, T>
>;

export const Form_MultilineStringInput = <T extends object, N extends boolean>({
    name,
    control,
    onChange,
    ...props
}: Form_MultilineStringInputProps<T, N>) => {
    const fieldProps = useField({
        name,
        control,
        onChange,
    });

    return (
        <Controlled_MultilineStringInput
            {...props}
            {...fieldProps}
        />
    );
};
